import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Crown, Sparkles } from 'lucide-react';
const subcategories = [{
  id: 'kings',
  title: 'Kings',
  icon: Crown,
  description: "Men's streetwear with royal attitude",
  image: 'https://images.unsplash.com/photo-1617137968427-85924c800a22?auto=format&fit=crop&q=80&w=800',
  seasonal: 'FW24',
  isNew: true
}, {
  id: 'queens',
  title: 'Queens',
  icon: Sparkles,
  description: "Women's fashion that commands respect",
  image: 'https://images.unsplash.com/photo-1609505848912-b7c3b8b4beda?auto=format&fit=crop&q=80&w=800',
  seasonal: 'FW24',
  isNew: true
}, {
  id: 'heir',
  title: 'Heir',
  icon: Crown,
  description: "Boys' apparel for young kings",
  image: 'https://images.unsplash.com/photo-1519457431-44ccd64a579b?auto=format&fit=crop&q=80&w=800',
  seasonal: 'Holiday Drop'
}, {
  id: 'heiress',
  title: 'Heiress',
  icon: Sparkles,
  description: "Girls' fashion for young queens",
  image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?auto=format&fit=crop&q=80&w=800',
  seasonal: 'Holiday Drop'
}];
export function ApparelSubcategoriesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-uncommon-black flex flex-col" data-id="element-147">
      <Header data-id="element-148" />

      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[400px] w-full overflow-hidden" data-id="element-149">
        <div className="absolute inset-0" data-id="element-150">
          <img src="https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=80&w=1920" alt="Apparel" className="w-full h-full object-cover opacity-50" data-id="element-151" />
          <div className="absolute inset-0 bg-gradient-to-t from-uncommon-black via-uncommon-black/50 to-transparent" data-id="element-152" />
        </div>

        <div className="absolute inset-0 flex flex-col justify-end pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-153">
          <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white mb-6 transition-colors" data-id="element-154">
            <ArrowLeft size={16} className="mr-2" data-id="element-155" /> Back to Home
          </Link>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-156">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4" data-id="element-157">
              <span className="text-uncommon-gold" data-id="element-158">U</span>NCMMN Apparel
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl" data-id="element-159">
              Choose your collection. Bold fashion for Kings, Queens, and the
              next generation.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Subcategories Grid */}
      <main className="flex-grow py-16 px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="max-w-7xl mx-auto" data-id="element-161">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-162">
            {subcategories.map((subcategory, index) => <Link to={`/collection/${subcategory.id}`} key={subcategory.id} data-id="element-163">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.1
            }} className="group relative h-[500px] overflow-hidden rounded-lg border border-uncommon-grey bg-uncommon-dark cursor-pointer" data-id="element-164">
                  {/* Background Image */}
                  <div className="absolute inset-0" data-id="element-165">
                    <img src={subcategory.image} alt={subcategory.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-40" data-id="element-166" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-167" />
                  </div>

                  {/* Seasonal Badge - Top Right */}
                  <div className="absolute top-4 right-4 z-10" data-id="element-168">
                    <div className="bg-uncommon-gold text-black px-3 py-1 text-xs font-bold uppercase tracking-wider" data-id="element-169">
                      {subcategory.seasonal}
                    </div>
                    {subcategory.isNew && <div className="bg-white text-black px-3 py-1 text-xs font-bold uppercase tracking-wider mt-2" data-id="element-170">
                        New Drop
                      </div>}
                  </div>

                  {/* Content */}
                  <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-171">
                    <div className="transform transition-transform duration-300 group-hover:-translate-y-2" data-id="element-172">
                      <div className="flex items-center gap-3 mb-3 text-uncommon-gold" data-id="element-173">
                        <subcategory.icon size={32} data-id="element-174" />
                        <span className="text-sm font-bold uppercase tracking-wider" data-id="element-175">
                          {subcategory.seasonal}
                        </span>
                      </div>

                      <h2 className="text-4xl md:text-5xl font-bold text-white mb-3" data-id="element-176">
                        <span className="text-uncommon-gold" data-id="element-177">U</span>NCMMN{' '}
                        {subcategory.title}
                      </h2>

                      <p className="text-gray-300 text-lg mb-6" data-id="element-178">
                        {subcategory.description}
                      </p>

                      <div className="inline-flex items-center text-white font-bold text-sm uppercase tracking-wider group-hover:text-uncommon-gold transition-colors bg-black/50 px-6 py-3 rounded" data-id="element-179">
                        Shop Collection
                      </div>
                    </div>
                  </div>
                </motion.div>
              </Link>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-180" />
    </div>;
}